import { Action } from '@ngrx/store';
import {UpgradeFirmWareParams} from '../firm-ware.model';

export enum FirmWareUpdateActionTypes {
  LoadFirmWareUpdates = '[FirmWareUpdate] Load FirmWareUpdates',
  GetFirmWareUpdates = '[FirmWareUpdate] Get FirmWareUpdates',
}

export class LoadFirmWareUpdates implements Action {
  readonly type = FirmWareUpdateActionTypes.LoadFirmWareUpdates;
}

export class GetFirmWareUpdates implements Action {
  readonly type = FirmWareUpdateActionTypes.GetFirmWareUpdates;
  constructor(public payload: UpgradeFirmWareParams[]) {}
}


export type FirmWareUpdateActions = LoadFirmWareUpdates
  | GetFirmWareUpdates;
